module.exports = __webpack_public_path__ + "lib/img/logo.a2dbd069.png";